import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PayrollBankEmployeePaymentDTO  {
    _originalTypeClassName = "zERP.BO.PayrollBankEmployeePaymentDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PayrollBankEmployeePaymentDTO.translate = translateService;
}
this.AdvanceAmount = null;
this.PayableAmount = null;
this.PayrollBankEmployeePaymentDTOKey = null;
this._key = this.PayrollBankEmployeePaymentDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
AdvanceAmount:any;
PayableAmount:any;
Employee:any;
private _PayrollBankEmployeePaymentDTOKey:any;
get PayrollBankEmployeePaymentDTOKey(): any {
    return this._PayrollBankEmployeePaymentDTOKey;
  }
set PayrollBankEmployeePaymentDTOKey(value: any) {
    this._PayrollBankEmployeePaymentDTOKey = value;
    this._key = value;
  }
static setEmployee = ($this, value) => {
var oldValue = $this.Employee;
$this.Employee = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.PayrollBankEmployeePaymentDTOKey == null || $this.PayrollBankEmployeePaymentDTOKey == 0;
            }


}